(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import baseLoadable from '@loadable/component';
import React from 'react';
import loadingimg from '../assets/static/loading.svg'; // import Home from '../pages/home';
// import Services from '../pages/services';
// import Login from '../pages/Login';
// // import NotFound from '../pages/NotFound';
// import NoMatch from '../pages/no-match';
// import ChangePassword from '../pages/users/ChangePassword';
// import AdminResetPassword from '../pages/users/AdminResetPassword';
// import Projects from '../pages/projects';
// import About from '../pages/about';
// import Contact from '../pages/contact';
// import ContactsList from '../pages/admin/contacts/ContactsList';
// import ContactsDetails from '../pages/admin/contacts/ContactsDetails';

function LoadingContent() {
  return /*#__PURE__*/React.createElement("div", {
    className: "contentloading"
  }, /*#__PURE__*/React.createElement("img", {
    src: loadingimg,
    alt: "Loading Content..."
  }));
}

function loadable(func) {
  return baseLoadable(func, {
    fallback: /*#__PURE__*/React.createElement(LoadingContent, null)
  });
}

const Home = loadable({
  resolved: {},

  chunkName() {
    return "pages-Home";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-Home" */
  '../pages/Home'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/Home");
    }

    return eval('require.resolve')("../pages/Home");
  }

});
const Amenities = loadable({
  resolved: {},

  chunkName() {
    return "pages-amenities";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-amenities" */
  '../pages/amenities'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/amenities");
    }

    return eval('require.resolve')("../pages/amenities");
  }

});
const Floorplans = loadable({
  resolved: {},

  chunkName() {
    return "pages-floorplans";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-floorplans" */
  '../pages/floorplans'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/floorplans");
    }

    return eval('require.resolve')("../pages/floorplans");
  }

});
const FloorplansStudio = loadable({
  resolved: {},

  chunkName() {
    return "pages-floorplans-studio";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-floorplans-studio" */
  '../pages/floorplans-studio'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/floorplans-studio");
    }

    return eval('require.resolve')("../pages/floorplans-studio");
  }

});
const Floorplans1Bed = loadable({
  resolved: {},

  chunkName() {
    return "pages-floorplans-1-bed";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-floorplans-1-bed" */
  '../pages/floorplans-1-bed'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/floorplans-1-bed");
    }

    return eval('require.resolve')("../pages/floorplans-1-bed");
  }

});
const Floorplans2Bed = loadable({
  resolved: {},

  chunkName() {
    return "pages-floorplans-2-bed";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-floorplans-2-bed" */
  '../pages/floorplans-2-bed'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/floorplans-2-bed");
    }

    return eval('require.resolve')("../pages/floorplans-2-bed");
  }

});
const Floorplans3Bed = loadable({
  resolved: {},

  chunkName() {
    return "pages-floorplans-3-bed";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-floorplans-3-bed" */
  '../pages/floorplans-3-bed'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/floorplans-3-bed");
    }

    return eval('require.resolve')("../pages/floorplans-3-bed");
  }

});
const Floorplans4Bed = loadable({
  resolved: {},

  chunkName() {
    return "pages-floorplans-4-bed";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-floorplans-4-bed" */
  '../pages/floorplans-4-bed'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/floorplans-4-bed");
    }

    return eval('require.resolve')("../pages/floorplans-4-bed");
  }

});
const Gallery = loadable({
  resolved: {},

  chunkName() {
    return "pages-gallery";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-gallery" */
  '../pages/gallery'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/gallery");
    }

    return eval('require.resolve')("../pages/gallery");
  }

});
const InteriorFeatures = loadable({
  resolved: {},

  chunkName() {
    return "pages-interior-features";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-interior-features" */
  '../pages/interior-features'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/interior-features");
    }

    return eval('require.resolve')("../pages/interior-features");
  }

});
const InteriorVideo = loadable({
  resolved: {},

  chunkName() {
    return "pages-interior-video";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-interior-video" */
  '../pages/interior-video'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/interior-video");
    }

    return eval('require.resolve')("../pages/interior-video");
  }

});
const Neighborhood = loadable({
  resolved: {},

  chunkName() {
    return "pages-neighborhood";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-neighborhood" */
  '../pages/neighborhood'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/neighborhood");
    }

    return eval('require.resolve')("../pages/neighborhood");
  }

});
const Contact = loadable({
  resolved: {},

  chunkName() {
    return "pages-contact";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-contact" */
  '../pages/contact'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/contact");
    }

    return eval('require.resolve')("../pages/contact");
  }

});
const ProductViewer = loadable({
  resolved: {},

  chunkName() {
    return "pages-product-viewer";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-product-viewer" */
  '../pages/product-viewer'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/product-viewer");
    }

    return eval('require.resolve')("../pages/product-viewer");
  }

});
const Login = loadable({
  resolved: {},

  chunkName() {
    return "pages-Login";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-Login" */
  '../pages/Login'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/Login");
    }

    return eval('require.resolve')("../pages/Login");
  }

});
const NoMatch = loadable({
  resolved: {},

  chunkName() {
    return "pages-no-match";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-no-match" */
  '../pages/no-match'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/no-match");
    }

    return eval('require.resolve')("../pages/no-match");
  }

});
const ChangePassword = loadable({
  resolved: {},

  chunkName() {
    return "pages-users-ChangePassword";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-users-ChangePassword" */
  '../pages/users/ChangePassword'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/users/ChangePassword");
    }

    return eval('require.resolve')("../pages/users/ChangePassword");
  }

});
const AdminResetPassword = loadable({
  resolved: {},

  chunkName() {
    return "pages-users-AdminResetPassword";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-users-AdminResetPassword" */
  '../pages/users/AdminResetPassword'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/users/AdminResetPassword");
    }

    return eval('require.resolve')("../pages/users/AdminResetPassword");
  }

});
const ContactsList = loadable({
  resolved: {},

  chunkName() {
    return "pages-admin-contacts-ContactsList";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-admin-contacts-ContactsList" */
  '../pages/admin/contacts/ContactsList'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/admin/contacts/ContactsList");
    }

    return eval('require.resolve')("../pages/admin/contacts/ContactsList");
  }

});
const ContactsDetails = loadable({
  resolved: {},

  chunkName() {
    return "pages-admin-contacts-ContactsDetails";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-admin-contacts-ContactsDetails" */
  '../pages/admin/contacts/ContactsDetails'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/admin/contacts/ContactsDetails");
    }

    return eval('require.resolve')("../pages/admin/contacts/ContactsDetails");
  }

});
const Sitemap = loadable({
  resolved: {},

  chunkName() {
    return "pages-sitemap";
  },

  isReady(props) {
    const key = this.resolve(props);

    if (this.resolved[key] !== true) {
      return false;
    }

    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }

    return false;
  },

  importAsync: () => import(
  /* webpackChunkName: "pages-sitemap" */
  '../pages/sitemap'),

  requireAsync(props) {
    const key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(resolved => {
      this.resolved[key] = true;
      return resolved;
    });
  },

  requireSync(props) {
    const id = this.resolve(props);

    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }

    return eval('module.require')(id);
  },

  resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../pages/sitemap");
    }

    return eval('require.resolve')("../pages/sitemap");
  }

});

const serverRoutes = (isLogged, redirect = true) => [// {
//id: 1,
//   path: '/',
//   component: !isLogged && redirect ? Login : Home,
//   exact: true,
// },
{
  id: 2,
  path: '/',
  component: Home,
  exact: true
}, {
  path: '/amenities',
  component: Amenities,
  exact: true
}, {
  path: '/floorplans',
  component: Floorplans,
  exact: true
}, {
  path: '/floorplans/studios',
  component: FloorplansStudio,
  exact: true
}, {
  path: '/floorplans/1-bedrooms',
  component: Floorplans1Bed,
  exact: true
}, {
  path: '/floorplans/2-bedrooms',
  component: Floorplans2Bed,
  exact: true
}, {
  path: '/floorplans/3-bedrooms',
  component: Floorplans3Bed,
  exact: true
}, {
  path: '/floorplans/4-bedrooms',
  component: Floorplans4Bed,
  exact: true
}, {
  path: '/gallery',
  component: Gallery,
  exact: true
}, {
  path: '/interior-features',
  component: InteriorFeatures,
  exact: true
}, {
  path: '/interior-video',
  component: InteriorVideo,
  exact: true
}, {
  path: '/neighborhood',
  component: Neighborhood,
  exact: true
}, {
  path: '/contact',
  component: Contact,
  exact: true
}, {
  path: '/product-viewer',
  component: ProductViewer,
  exact: true
}, {
  id: 3,
  path: '/sitemap',
  component: Sitemap,
  exact: true
}, {
  id: 4,
  path: '/login',
  component: Login,
  exact: true,
  layout: 'none'
}, {
  id: 5,
  path: '/admin/change-password',
  component: !isLogged && redirect ? Login : ChangePassword,
  exact: true,
  layout: 'admin'
}, {
  id: 6,
  path: '/admin/reset-password',
  component: !isLogged && redirect ? Login : AdminResetPassword,
  exact: true,
  layout: 'admin'
}, {
  id: 7,
  path: '/admin',
  component: !isLogged && redirect ? Login : ContactsList,
  exact: true,
  layout: 'admin'
}, {
  id: 8,
  path: '/admin/contacts',
  component: !isLogged && redirect ? Login : ContactsList,
  exact: true,
  layout: 'admin'
}, {
  id: 9,
  path: '/admin/contacts/:id',
  component: !isLogged && redirect ? Login : ContactsDetails,
  exact: true,
  layout: 'admin'
}, {
  id: 10,
  path: '/loading',
  component: LoadingContent,
  exact: true
}, {
  id: 11,
  name: 'NotFound',
  component: NoMatch
}];

const _default = serverRoutes;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LoadingContent, "LoadingContent", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(loadable, "loadable", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Home, "Home", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Amenities, "Amenities", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Floorplans, "Floorplans", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(FloorplansStudio, "FloorplansStudio", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Floorplans1Bed, "Floorplans1Bed", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Floorplans2Bed, "Floorplans2Bed", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Floorplans3Bed, "Floorplans3Bed", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Floorplans4Bed, "Floorplans4Bed", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Gallery, "Gallery", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(InteriorFeatures, "InteriorFeatures", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(InteriorVideo, "InteriorVideo", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Neighborhood, "Neighborhood", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Contact, "Contact", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(ProductViewer, "ProductViewer", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Login, "Login", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(NoMatch, "NoMatch", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(ChangePassword, "ChangePassword", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(AdminResetPassword, "AdminResetPassword", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(ContactsList, "ContactsList", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(ContactsDetails, "ContactsDetails", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(Sitemap, "Sitemap", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(serverRoutes, "serverRoutes", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/serverRoutes.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();